import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DoctorListPage from "./pages/DoctorListPage";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/doctor-list" element={<DoctorListPage />} />
      </Routes>
    </Router>
  );
};

export default App;
